import React from 'react';
import { motion } from 'framer-motion';
import { ProductVisual } from '../products/ProductVisual';
import { SiblingFigure } from '../characters/SiblingFigure';
import { products } from '../../data/products';
interface FamilyLineupProps {
  compact?: boolean;
}

/** The portfolio, read as a family. */
export function FamilyLineup({
  compact = false
}: FamilyLineupProps) {
  return <figure className={['overflow-hidden rounded-[24px] bg-background', compact ? 'mt-6 p-4' : 'mt-9 p-6'].join(' ')} data-id="element-142" data-mp="3vnp0hwjmxp1c">
      <div className={['grid grid-cols-2', compact ? 'gap-4' : 'gap-5 sm:grid-cols-4'].join(' ')} data-id="element-143" data-mp="3qvp94shms4gd">
        {products.map((product, i) => <motion.div key={product.id} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.4
      }} transition={{
        delay: i * 0.1,
        duration: 0.55,
        ease: [0.22, 1, 0.36, 1]
      }} className="flex flex-col items-center text-center" data-id="element-144" data-mp="3hxljpl3iynja" data-mpi={i}>
            <div className={compact ? 'flex h-[104px] items-end' : 'flex h-[132px] items-end'} data-id="element-145" data-mp="1rdlyyjxkj7oz">
              <ProductVisual product={product.id} className="h-full w-auto" data-id="element-146" data-mp="1dm7gce7kp8ig" />
            </div>
            <SiblingFigure role={product.answer} className={compact ? 'mt-3 h-9 w-9' : 'mt-4 h-11 w-11'} data-id="element-147" data-mp="1dke8ivl84i8v" />
            <span className={['mt-2 font-heading leading-tight text-white', compact ? 'text-[12.5px]' : 'text-[14px]'].join(' ')} data-id="element-148" data-mp="26bxycycbsuju">
              {product.shortName}
            </span>
            <span className="mt-1 font-body text-[10px] uppercase tracking-[0.12em] text-primary" data-id="element-149" data-mp="21btcessnf7m8">
              {product.answerLabel}
            </span>
            {!compact && <span className="mt-2 font-body text-[11px] leading-snug text-white/50" data-id="element-150" data-mp="kzmn187jemc9">
                {product.traits.join(' · ')}
              </span>}
          </motion.div>)}
      </div>
      <figcaption className={['border-t border-white/10 font-body leading-relaxed text-white/55', compact ? 'mt-4 pt-3 text-[11px]' : 'mt-6 pt-4 text-[12px]'].join(' ')} data-id="element-151" data-mp="5wczj31gc8g7">
        Three composites for different jobs, plus the late arrival that changes how any
        of them behaves.
      </figcaption>
    </figure>;
}